import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { ROUTES } from '@aibees/elephant/router';
import { SearchType } from '@aibees/elephant/types';
import { useMatchRoute } from '@aibees/shared/hooks';
import { format } from 'date-fns';
import { useMemo } from 'react';

const FILE_NAMES = {
  [SearchType.Company]: 'Account Export',
  [SearchType.People]: 'Contact Export',
};

export function useDefaultFileName() {
  const type = useSearchTypeFromRoute();
  const peoplePage = useMatchRoute(ROUTES.people);

  return useMemo(() => {
    const todayDate = format(new Date(), 'MMM dd');
    const baseName = type
      ? FILE_NAMES[type]
      : peoplePage
      ? FILE_NAMES[SearchType.People]
      : FILE_NAMES[SearchType.Company];

    return `${baseName}-${todayDate}`;
  }, [type, peoplePage]);
}
